import { FC } from "react";
import { IconPropsType } from ".";

export const AddUser: FC<IconPropsType> = (props) => {
  return (
    <svg
      width="14"
      height="13"
      viewBox="0 0 14 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="10" cy="6" r="1.25" stroke={props.color} strokeWidth="1.5" />
      <mask id="path-2-inside-1_185_1268" fill={props.color}>
        <path d="M7 11C7 9.89543 7.89543 9 9 9H11C12.1046 9 13 9.89543 13 11V12C13 12.5523 12.5523 13 12 13H8C7.44772 13 7 12.5523 7 12V11Z" />
      </mask>
      <path
        d="M7 11C7 9.89543 7.89543 9 9 9H11C12.1046 9 13 9.89543 13 11V12C13 12.5523 12.5523 13 12 13H8C7.44772 13 7 12.5523 7 12V11Z"
        stroke={props.color}
        strokeWidth="3"
        mask="url(#path-2-inside-1_185_1268)"
      />
      <path
        d="M3.5 1.5V6.5M6 4H1"
        stroke={props.color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
};
